import React from 'react'
import CardUploadImage from '../CardUploadImage'

const CardFotoInforme = ( {title, htmlFor} ) => {
    return (
        <>
        <div className="column">
        <h4 className="text-center mb-perso"> { title } </h4>
            <CardUploadImage htmlFor={htmlFor} />
            
            </div>
        </>
    )
}

export default CardFotoInforme
